import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { SEOHead } from "@/components/SEOHead";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const { t, language } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const seoTitle = language === 'fr' 
    ? "Page non trouvée - Erreur 404"
    : "Page Not Found - Error 404";
    
  const seoDescription = language === 'fr'
    ? "La page que vous recherchez n'existe pas. Retournez à l'accueil pour découvrir nos formations IA pour avocats et juristes."
    : "The page you are looking for does not exist. Return to home to discover our AI training for lawyers and legal professionals.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/30">
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        canonicalUrl={`https://gaius-tech.com${location.pathname}`}
      />
      <div className="text-center px-4">
        <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          {t('notFoundTitle')}
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
          {t('notFoundDesc')}
        </p>
        <Button asChild size="lg" className="bg-primary hover:bg-primary/90">
          <Link to="/" className="flex items-center">
            <Home className="mr-2 w-5 h-5" />
            {t('returnHome')}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
